import React from "react";
import { useSelector } from "react-redux";
import FilterCategory from "../../MarketPlace/FilterCategory";
import { serviceTypeName } from "../../../utils/constant";
const ExplorePhotoFilter = ({
  handleFilter,
  clearFilter,
  setChecked,
  checked,
}) => {
  const photoServiceCategoryData = useSelector(
    (state) => state?.serviceCategory?.photoServiceCategoryData
  );
  const handleFilterType = (categoryId) => {
    handleFilter(serviceTypeName?.Photo, categoryId);
  };
  return (
    <>
      <FilterCategory
        data={photoServiceCategoryData}
        handleFilterApply={handleFilterType}
        clearFilter={clearFilter}
        checked={checked}
        setChecked={setChecked}
      />
    </>
  );
};

export default ExplorePhotoFilter;
